module.exports = function() {
  return new Worker(__webpack_public_path__ + "scripts/main.worker-be1e1fa7fb9be561808b.js");
};